module.exports = __webpack_public_path__ + "img/icon.6a9b590e.jpeg";